module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "enc"
  }, [_c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre1"
    }
  }, [_vm._v("List of Figures")])]), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Foreword by Ashley Null")])]), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Preface")])]), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Acknowledgments")])]), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("Introduction: Peering Over the Archbishop’s Shoulder")])]), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("Part 1: Cranmer’s Gospel-Centered"), _c('br'), _vm._v("Theology Established: Paul’s"), _c('br'), _vm._v("Doctrine of Justification"), _c('br'), _vm._v("by Faith Alone")])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_c('span', {
    staticClass: "mev4"
  }, [_vm._v("1")]), _vm._v(" "), _c('b', [_vm._v("The Position of "), _c('i', [_vm._v("Sola Fide")]), _vm._v(" in Cranmer’s Theology")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev4"
  }, [_vm._v("2")]), _vm._v(" "), _c('b', [_vm._v("The Grammar of "), _c('i', [_vm._v("Sola Fide")]), _vm._v(" Defined")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev4"
  }, [_vm._v("3")]), _vm._v(" "), _c('b', [_vm._v("The Grammar of "), _c('i', [_vm._v("Sola Fide")]), _vm._v(" in Cranmer")])])]), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: Cranmer’s Gospel-Centered Theology Applied: Analysis of Worship According to the Book of Common Prayer")])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev4"
  }, [_vm._v("4")]), _vm._v(" "), _c('b', [_vm._v("“Not I, But Christ” Structurally")]), _c('br'), _vm._v("Sola Fide "), _c('i', [_vm._v("in Cranmer’s Liturgical Form")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev4"
  }, [_vm._v("5")]), _vm._v(" "), _c('b', [_vm._v("“Not I, But Christ” Theologically")]), _c('br'), _vm._v("Sola Fide "), _c('i', [_vm._v("in Cranmer’s Liturgical Terminology")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev4"
  }, [_vm._v("6")]), _vm._v(" "), _c('b', [_vm._v("“Not I, But Christ” Ceremonially")]), _c('br'), _vm._v(" Sola Fide "), _c('i', [_vm._v("in Cranmer’s Liturgical Actions and Assisting Tools")])])]), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev4"
  }, [_vm._v("7")]), _vm._v(" "), _c('b', [_vm._v("“Not I, But Christ” Devotionally and Homiletically")]), _c('br'), _vm._v("Sola Fide "), _c('i', [_vm._v("in Cranmer’s Liturgical Piety and Preaching")])])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Defining and Imagining Gospel-Centered Worship in the Twenty-First Century")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Index")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dynamics of Christian Worship")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Worship by Faith Alone")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0